<template>
    <div class="">
        <NavigationBar></NavigationBar>
        <button @click="goSet" style="width: 100px; height: 100px; border: 1px solid #000">
            goSet
        </button>
    </div>
</template>

<script>
    import NavigationBar from '@/components/NavigationBar/NavigationBar.vue';
    import { RouterNames } from '@/router';
    // import Tips from '@/components/Tips/Tips';
    export default {
        name: 'HomePage',
        components: { NavigationBar },
        methods: {
            goSet() {
                this.$router.push({ name: RouterNames.SetingHome });
            },
        },
    };
</script>

<style scoped></style>
